import { useCallback, type RefObject } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { type IAppState } from 'shared/common/state';
import { type IJsonQuery } from 'shared/json_query';
import { setSuggestionDistancesSeoText } from 'shared/serp/state/suggestions';
import { fetchGeoTagsSafe } from 'shared/services/fetchGeoTags';
import { useApplicationContext } from 'shared/utils/applicationContext';
import { getSuggestionDistancesSeoText } from 'shared/utils/seo_text';

import { CAT_PAGE_PATHNAME } from './constants';

interface IParameters {
  jsonQuery: IJsonQuery;
  searchVersionRef: RefObject<number>;
}

export function useUpdateSuggestionDistancesSeoText({ jsonQuery, searchVersionRef }: IParameters) {
  const ctx = useApplicationContext();
  const dispatch = useDispatch();
  const subdomain = useSelector((state: IAppState) => state.currentSubdomain);
  const directions = useSelector((state: IAppState) => state.directions);

  return useCallback(
    async (searchVersion: number) => {
      try {
        const geoTagsData = await fetchGeoTagsSafe(ctx, { jsonQuery, subdomain });

        if (searchVersion !== searchVersionRef.current) {
          return;
        }

        const suggestionDistancesSeoText =
          window.location.pathname === CAT_PAGE_PATHNAME ? '' : getSuggestionDistancesSeoText(geoTagsData, directions);
        dispatch(setSuggestionDistancesSeoText(suggestionDistancesSeoText));
      } catch (_error) {
        if (searchVersion === searchVersionRef.current) {
          dispatch(setSuggestionDistancesSeoText(''));
        }
      }
    },
    [ctx, directions, dispatch, jsonQuery, searchVersionRef, subdomain],
  );
}
